import React, { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
// import axios from "axios";
import { useHistory } from "react-router-dom";

import { Header } from "../components";
import routes from "../routes/routes";
import { useLocation } from "react-router-dom";
import { withAuthHeader } from "../routes/authRequest";

const MessageMember = () => {
    const history = useHistory()
    const { state: { member } } = useLocation()
    const { register, handleSubmit, errors } = useForm();
    const [message, setMessage] = useState("");
    const mutation = useMutation(memberData => withAuthHeader.post(routes.api.locations.messageMember, memberData))

    const onSubmit = async (inputData) => {
        console.log("response", inputData);
        await mutation.mutate({ ...inputData, id: member.id }, {
            onSuccess: async (inputData) => {
                setMessage(["message sent"])
                console.log("response", inputData);
                setTimeout(() => {
                    history.push(routes.public.users)
                }, 2000);
            },
            onError: async (error) => {
                setMessage(["Something went wrong, please try again"])
            },
        })
    };

    // console.log(member);
    // console.log(location);
    return (
        <div className="mainpanel">
            {/* <!-- pageheader --> */}
            <Header />

            <div className="contentpanel">

                <div className="col-md-10 col-md-offset-1">
                    <form className="panel panel-default" onSubmit={handleSubmit(onSubmit)}>
                        <p className="text-success">{message[0]}</p>

                        <div className="panel-heading">
                            <div className="panel-btns">
                                <a
                                    href="/#"
                                    className="panel-minimize tooltips"
                                    data-toggle="tooltip"
                                    title="Minimize Panel"
                                >
                                    <i className="fa fa-minus">-</i>
                                </a>
                                <a
                                    href="/#"
                                    className="panel-close tooltips"
                                    data-toggle="tooltip"
                                    title="Close Panel"
                                >
                                    <i className="fa fa-times"></i>
                                    X
                                </a>
                            </div>
                            {/* <!-- panel-btns --> */}
                            <h4 className="panel-title">Message Member</h4>
                            <p>Send message to members by filling and submitting the form.</p>
                        </div>
                        {/* <!-- panel-heading --> */}
                        <div className="panel-body">
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label>Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        placeholder="Title"
                                        className="form-control"
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="title"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label>Type</label>
                                    <select
                                        name="messageType"
                                        placeholder="messageType"
                                        className="form-control"
                                        ref={register({
                                            required: "This input is required.",
                                        })}
                                    >
                                        <option value="email">Email</option>
                                        <option value="sms">SMS</option>
                                        <option value="whatsApp">WhatsApp</option>
                                    </select>
                                    <ErrorMessage
                                        errors={errors}
                                        name="messageType"
                                        render={(messages) => {
                                            console.log("messages", messages);
                                            return messages
                                                ? Object.entries(messages).map(([type, message]) => (
                                                    <p className="text-danger">{message}</p>
                                                ))
                                                : null;
                                        }}
                                    />
                                </div>

                            </div>
                            {/* <!-- row --> */}

                            <label>Description</label>
                            <textarea
                                className="form-control"
                                name="message"
                                rows="5"
                                placeholder="message"
                                ref={register({
                                    required: "This input is required.",
                                    minLength: {
                                        value: 10,
                                        message: "This input must exceed 10 characters",
                                    }
                                })}
                            ></textarea>
                            <ErrorMessage
                                errors={errors}
                                name="message"
                                render={(messages) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p className="text-danger">{message}</p>
                                        ))
                                        : null;
                                }}
                            />
                        </div>
                        {/* <!-- panel-body --> */}
                        <div className="panel-footer">
                            <button type="submit" className="btn btn-primary">Send</button>
                        </div>
                        {/* <!-- panel-footer --> */}
                    </form>
                    {/* <!-- panel --> */}
                </div>
            </div>
        </div>
    );
};

export default MessageMember;
